import Tippy from 'tippy.js'

// noinspection JSUnusedGlobalSymbols
export default class Tooltip
{
	static init()
	{
		Tippy('[data-tippy-content]', {allowHTML: true})
	}
}
